import { render } from "./CceData.vue?vue&type=template&id=652d5ef5"
import script from "./CceData.vue?vue&type=script&lang=js"
export * from "./CceData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__